import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import Topbar from '../PulseSurvey/Topbar';
import { Api } from '../../api';
import { useSearchParams } from 'react-router-dom';
import { CompanyApi } from '../../api/companyApi';
import PropTypes from 'prop-types';
import moment from 'moment';
import { featuresHealthVideosPageData as mainPageData } from '../../utils/pageContent';

const LoadVideo = ({ previewVideo, setMin, setSec }) => {
  const videoEl = useRef(null);

  const handleLoadedMetadata = () => {
    const video = videoEl.current;
    if (!video) return;
    let minutes = Math.floor(video.duration / 60);
    let extraSeconds = video.duration % 60;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let sec = parseInt(extraSeconds);
    sec = sec < 10 ? '0' + sec : sec;
    setMin(minutes);
    setSec(sec);
  };

  function changeSource(url) {
    const video = document.getElementById('video');
    video.src = url;
  }

  useEffect(() => {
    changeSource(previewVideo);
  }, [previewVideo]);

  return (
    <video
      id="video"
      ref={videoEl}
      onLoadedMetadata={handleLoadedMetadata}
      className="w-full h-[500px] object-cover object-center rounded-2xl"
      controls
    >
      <source className="" src={previewVideo} />
    </video>
  );
};

LoadVideo.propTypes = {
  previewVideo: PropTypes.any,
  setSec: PropTypes.any,
  setMin: PropTypes.any
};

const ViewHealthVideo = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [healthVideoData, setHealthVideoData] = useState([]);
  const [loader, setloader] = useState(false);
  const [minutes, setMinutes] = useState(0);
  // const [minutes2, setMinutes2] = useState(0);
  const [sec, setSec] = useState(0);
  // const [sec2, setSec2] = useState(0);
  const [createdDate, setCreatedDate] = useState(null);
  const pageData = mainPageData.viewHealthVideosPageData;

  const fetchList = async (id) => {
    setloader(true);
    try {
      const response = await CompanyApi.getSpecificGuidance(id);
      const responseData = response?.data || {};
      if (responseData?.meta?.code === 1) {
        setHealthVideoData(responseData?.data);
        const duration = responseData?.data?.duration?.split(':');
        if (responseData?.data?.video_url) {
          setMinutes(parseInt(duration[0]));
          setSec(parseInt(duration[1]));
        }
      }
    } catch (error) {
      console.error('Error fetching get data:', error);
    } finally {
      setloader(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchList(id);
    }
  }, [id]);

  useEffect(() => {
    if (healthVideoData.category_ids) {
      const selectCategory = categoriesList.filter((category) =>
        healthVideoData.category_ids.includes(category._id)
      );
      setSelectedCategory(selectCategory);
    }
    if (healthVideoData.createdOn) {
      const now = moment();
      const created = moment(healthVideoData.createdOn);
      let addedText;
      if (now.isSame(created, 'day')) {
        addedText = pageData.addedTodayText;
      } else {
        addedText = `${pageData.addedText} ${created.fromNow(true)} ${pageData.agoText}`;
      }
      setCreatedDate(addedText);
    }
  }, [healthVideoData, categoriesList]);

  useEffect(() => {
    Api.getCategoriesById(19).then((res) => {
      setCategoriesList(
        res?.data?.data?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?.name
          };
        })
      );
    });
  }, []);

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>
      <Topbar title={pageData.pageTitle} />
      <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
        <div>
          <LoadVideo
            previewVideo={healthVideoData?.video_url}
            setMin={setMinutes}
            setSec={setSec}
          />
        </div>

        <div className="mt-4 bg-shoorah-borderGray rounded-xl px-4 py-6">
          <div className="flex flex-col sm:flex-row justify-between sm:items-center items-start gap-3">
            <p>{healthVideoData?.display_name}</p>
            {/* <p>4.7K views | {createdDate ? createdDate : ""}</p> */}
            <p>{createdDate ? createdDate : ''}</p>
          </div>
          <div className="flex flex-col sm:flex-row justify-start sm:items-center items-start gap-3 mt-6">
            {selectedCategory?.map((category, index) => (
              <p
                key={index}
                className="bg-shoorah-secondary p-3 px-4 rounded-3xl text-shoorah-darkBg"
              >
                {category.name}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewHealthVideo;
